import React, { useEffect } from "react";
import ReactMarkdown from "react-markdown";
import { useQuery } from "react-query";
import styled from "styled-components";
import { getInternalPortalFaqs } from "../api/api";
import {
  GLOBAL_MEDIA_QUERIES,
  primaryColors,
  secondaryColors,
} from "../constatnts";
import { ImagesEntity, INews } from "../types/news";
import { useTranslation } from "react-i18next";
import { useMedia } from "react-media";
import { IMedia } from "../types/types";
import { Helmet } from "react-helmet";
import InnerPageLayout from "../Components/Layout/InnerPageLayout";
import { useParams } from "react-router-dom";
import Accordion from "react-bootstrap/esm/Accordion";
import { IFaqItem } from "../types/faq";
import LayoutTop from "../Components/Layout/LayoutTop";
import LayoutBottom from "../Components/Layout/LayoutBottom";
interface IProps {
  id?: string;
  category?: string;
}
const FaqsPage = (props: IProps) => {
  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });
  let { id,category} = useParams(); 

  const { t, i18n } = useTranslation();

  const { isLoading, error, data, isFetching, refetch }: any = useQuery(
    "faqQuestionsData",
    () => getInternalPortalFaqs({ subCategory: id || "1", language: i18n.language })
  );

  useEffect(() => {
    refetch();
  }, [i18n.language]);
  if (isLoading) return <div></div>;

  if (error) return <div></div>;

  let newsItem: INews = data["data"];
  return (
    <>
      <LayoutTop />


      <div className="wrapper3 wrapper4">
        <div className="container-fluid">
          <h4 className="shape-round mb-lg-5 pb-5">الأسئلة الشائعة - {category}</h4>
          <Accordion defaultActiveKey="0" >
            {data.data.map((faqRow: IFaqItem,index: any) => (
              <Accordion.Item eventKey={index}>
                <Accordion.Header>{faqRow.Title}</Accordion.Header>
                <Accordion.Body>
                  <ReactMarkdown>{faqRow.Description}</ReactMarkdown> 
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
        </div>
      </div>
      <LayoutBottom />

    </>


   
  );
};


export default FaqsPage;
